import React, {Component} from "react";
import PropTypes from "prop-types";
import $ from "jquery";
import "bootstrap";

class LongText extends Component {
    constructor(props, context) {
        super(props, context);

        this.elem = React.createRef();
    }

    get showText() {
        if (this.props.text && this.props.text.length > this.props.charCount) {
            return this.props.text.slice(0, this.props.charCount - 3).trim() + "...";
        }
        return this.props.text;
    }

    get tooltipText() {
        if (this.props.text && this.props.text.length > this.props.charCount) {
            return this.props.text;
        }
        return null;
    }

    initializeBsTooltips = () => {
        if (this.tooltipText) {
            $(this.elem.current).tooltip();
        }
    };

    componentDidMount() {
        this.initializeBsTooltips();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.text !== this.props.text) {
            $(this.elem.current).tooltip('dispose');
            this.initializeBsTooltips();
        }
    }

    componentWillUnmount() {
        if (this.tooltipText) {
            $(this.elem.current).tooltip('hide');
        }
    }

    render() {
        if (!this.props.text) {
            return null;
        }

        return (
            <span ref={this.elem}
               className={this.props.spanClass}
               data-toggle="tooltip"
               data-placement={this.props.placement}
               title={this.tooltipText}
            >{this.showText}</span>
        );
    }
}

LongText.propTypes = {
    text: PropTypes.string.isRequired,
    charCount: PropTypes.number,
    placement: PropTypes.string,
    spanClass: PropTypes.string
};

LongText.defaultProps = {
    charCount: 50,
    placement: "top",
    spanClass: ""
};

export default LongText;